import { observer } from 'mobx-react-lite'
import { Outlet, useLoaderData } from 'react-router'
import { useActivation } from '@/hooks/view-model-hooks'
import type { CallCenterViewLoaderData } from '@/features/call-center/call-center-route-loaders'
import { type CallCenterViewModel } from '@/features/call-center/CallCenterViewModel'

export default observer(function CallCenterContainer() {
  const data = useLoaderData<CallCenterViewLoaderData>()
  return data ? <CallCenterViewContainer vm={data.vm} /> : null
})

interface CallCenterViewContainerProps {
  vm: CallCenterViewModel
}

const CallCenterViewContainer = observer(function CallCenterViewContainer({
  vm,
}: CallCenterViewContainerProps) {
  useActivation(vm)

  return <Outlet context={vm} />
})
